// src/app/chartjs-register.ts

import {
  Chart,
  ArcElement,
  BarElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale
} from 'chart.js';

import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(
  ArcElement,
  BarElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
  CategoryScale,
  LinearScale,
  ChartDataLabels
);
